// extracted by mini-css-extract-plugin
export var container = "_46-0";
export var icon = "_46-1";
export var text = "_46-2";